import { Slider } from "@mui/material";
import { Dispatch, SetStateAction } from "react"
import MuiInput from '@mui/material/Input';
import { styled, useTheme } from '@mui/material/styles';

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function HorizontalNumberSlider({
    label,
    threshold,
    setThreshold,
    hasBorderAndPadding,
    range,
}: {
    label: string,
    threshold: number,
    setThreshold: Dispatch<SetStateAction<number>>,
    hasBorderAndPadding: boolean,
    range?: {
        min: number,
        max: number,
        step: number,
        inputStep?: number,
    },
}) {
    const theme = useTheme();
    const sliderRange = range ?? { min: 0.01, max: 0.99, step: 0.01, inputStep: 0.1 };

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        setThreshold(newValue as number);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setThreshold(event.target.value === '' ? 0 : Number(event.target.value));
    };

    const handleBlur = () => {
    if (threshold < sliderRange.min) {
        setThreshold(sliderRange.min);
    } else if (threshold > sliderRange.max) {
        setThreshold(sliderRange.max);
    }
    };


    return (
        <div className={`w-full max-w-[600px] flex justify-between items-center gap-4 ${hasBorderAndPadding ? 'h-[44px] px-4 border border-outline' : ''}  bg-white rounded-lg`}>
            <p className="text-[14px] font-semibold text-nowrap text-default">{label}</p>

            <div className="grow flex items-center">
                <Slider
                    value={typeof threshold === 'number' ? threshold : 0}
                    onChange={handleSliderChange}
                    step={sliderRange.step}
                    min={sliderRange.min}
                    max={sliderRange.max}
                    size="small"
                    aria-labelledby="input-slider"
                    sx={{
                        color: theme.palette.primary.main,
                        width: '250px'
                    }}
                />
            </div>

            <Input
                value={threshold}
                disableUnderline={true}
                sx={{
                    fontFamily: 'Montserrat',
                    fontWeight: 600,
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        opacity: 1, // Force the arrows to show
                        WebkitAppearance: 'inner-spin-button',
                    },
                }}
                size="small"
                style={{
                    width: 80,
                }}
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                step: sliderRange.inputStep ?? sliderRange.step,
                min: sliderRange.min,
                max: sliderRange.max,
                type: 'number',
                'aria-labelledby': 'input-slider',
                style: {
                    padding: 0,
                }
                }}
            />
        </div>
    )
}